"use client";

import { FaLink } from "@/components/icons";
import { useState } from "react";

interface CopyLinkButtonProps {
  url: string;
  className?: string;
}

export default function CopyLinkButton({
  url,
  className = "",
}: CopyLinkButtonProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  return (
    <button
      onClick={handleCopy}
      aria-label={copied ? "Link copied!" : "Copy link"}
      className={`flex h-10 w-10 flex-none items-center justify-center rounded-md border border-line-strong bg-ink text-xs text-inverse dark:border-line-strong dark:bg-theme-dark-background dark:text-theme-light transition-colors ${
        copied ? "border-green-500 dark:border-green-500" : ""
      } ${className}`}
      title={copied ? "Link copied!" : "Copy link"}
    >
      {copied ? (
        <span className="text-status-positive">✓</span>
      ) : (
        <FaLink size={20} />
      )}
    </button>
  );
}
